module.exports = __webpack_public_path__ + "static/media/TCcovergif.b7c0ad75.gif";